import React, { Component } from 'react';
// import { Link } from 'react-router-dom';
import '../Styles/css/Music.css';
import { Footer } from '../Components';

export default class Music extends Component {

    render() {

        return (
            <div className="Music">
                <h1>MUSIC</h1>

                <div className="album over-imaginary">
                    <iframe className="music-iframe" src="https://bandcamp.com/EmbeddedPlayer/album=3769518090/size=large/bgcol=333333/linkcol=0687f5/minimal=true/transparent=true/" seamless>
                        <a href="http://flaural.bandcamp.com/album/postponement">Postponement by Flaural</a>
                    </iframe>
                    <div className="title">
                        <span>Postponement</span>
                    </div>
                    <div className="links">
                        <a target="_blank" rel="noopener noreferrer" href="https://itunes.apple.com/nz/album/over-imaginary-cigarettes-ep/id1086694676">iTunes</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://flaural.bandcamp.com/album/over-imaginary-cigarettes">Bandcamp</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/album/3zjIhGr08wdejsjhgGVTd2">Spotify</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://soundcloud.com/flaural-1">Soundcloud</a>
                    </div>
                </div>

                <div className="album over-imaginary">
                    <iframe className="music-iframe" title="Over Imaginary Cigarettes" src="https://bandcamp.com/EmbeddedPlayer/album=2158872414/size=large/bgcol=333333/linkcol=e99708/minimal=true/transparent=true/" seamless>
                        <a href="http://flaural.bandcamp.com/album/over-imaginary-cigarettes">Over Imaginary Cigarettes by Flaural</a>
                    </iframe>
                    <div className="title">
                        <span>Over Imaginary Cigarettes</span>
                    </div>
                    <div className="links">
                        <a target="_blank" rel="noopener noreferrer" href="https://itunes.apple.com/nz/album/over-imaginary-cigarettes-ep/id1086694676">iTunes</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://flaural.bandcamp.com/album/over-imaginary-cigarettes">Bandcamp</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/album/3zjIhGr08wdejsjhgGVTd2">Spotify</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://soundcloud.com/flaural-1">Soundcloud</a>
                    </div>
                </div>

                <div className="album thin-king">
                    <iframe className="music-iframe" title="Thin King" src="https://bandcamp.com/EmbeddedPlayer/album=860119598/size=large/bgcol=333333/linkcol=e99708/minimal=true/transparent=true/" seamless>
                        <a href="http://flaural.bandcamp.com/album/thin-king">Thin King by Flaural</a>
                    </iframe>
                    <div className="title">
                        <span>Thin King</span>
                    </div>
                    <div className="links">
                        <a target="_blank" rel="noopener noreferrer" href="https://itunes.apple.com/nz/album/thin-king-ep/id1050694019">iTunes</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://flaural.bandcamp.com/album/thin-king">Bandcamp</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://open.spotify.com/album/07AY0sQtuTKv0UjAeHnRbr">Spotify</a>
                        <a target="_blank" rel="noopener noreferrer" href="https://soundcloud.com/flaural-1">Soundcloud</a>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/Music.js